import { useEffect, useRef, useId, useMemo } from 'react';
import { useScrollNavigationContext } from './context.js';
export const useScrollNavigation = (title, order, options) => {
    const { registerSection, unregisterSection } = useScrollNavigationContext();
    const scrollToRef = useRef(null);
    const generatedId = useId();
    const { id: providedId, error, dataTestId } = options || {};
    const id = providedId || generatedId;
    useEffect(() => {
        if (scrollToRef.current) {
            registerSection({
                id,
                title,
                ref: scrollToRef,
                order,
                error,
                dataTestId,
            });
        }
    }, [id, title, order, error, dataTestId, registerSection]);
    useEffect(() => {
        return () => {
            unregisterSection(id);
        };
    }, [id, unregisterSection]);
    return useMemo(() => ({ scrollToRef, id }), [id]);
};
